export const services = [
  {
    id: 1,
    title: "Garden Maintenance",
    description: "Comprehensive garden maintenance including lawn mowing, hedge trimming, weeding, and general upkeep. Professional service to keep your garden looking its best all year round.",
    image: "https://customer-assets.emergentagent.com/job_balham-gardening-hub/artifacts/iavpo09s_Garden%20Maintenance.jpeg",
    features: ["Lawn Mowing", "Hedge Trimming", "Weeding", "General Upkeep", "Seasonal Maintenance"]
  },
  {
    id: 2,
    title: "Garden Clearance",
    description: "Complete garden clearance services including removal of overgrown vegetation, waste disposal, and site preparation. Fast and efficient clearance with professional waste removal.",
    image: "https://customer-assets.emergentagent.com/job_balham-gardening-hub/artifacts/tu9u2wbq_Garden%20Clearance.jpeg",
    features: ["Overgrown Garden Clearance", "Waste Removal", "Site Preparation", "Ivy Removal", "Thorny Bush Disposal"]
  },
  {
    id: 3,
    title: "Hedge Trimming & Removal",
    description: "Professional hedge trimming and removal services. Expert maintenance to keep your hedges neat and healthy, or complete removal when needed.",
    image: "https://customer-assets.emergentagent.com/job_balham-gardening-hub/artifacts/ccw4wf98_Hedge%20Trimming.jpeg",
    features: ["Hedge Trimming", "Hedge Removal", "Hedge Shaping", "Pruning", "Cleanup Service"]
  },
  {
    id: 4,
    title: "Turfing",
    description: "Professional turf laying services to create beautiful, lush lawns. From ground preparation to final installation of premium quality turf.",
    image: "https://customer-assets.emergentagent.com/job_balham-gardening-hub/artifacts/p467qw39_Turfing.jpeg",
    features: ["Ground Preparation", "Turf Installation", "Lawn Creation", "Soil Treatment", "Aftercare Advice"]
  },
  {
    id: 5,
    title: "Lawn Care",
    description: "Professional lawn care services including mowing, edging, weed treatment, and overseeding. Keep your lawn healthy and beautiful throughout the year.",
    image: "https://customer-assets.emergentagent.com/job_balham-gardening-hub/artifacts/84y7gk19_Lawn%20Care.jpeg",
    features: ["Lawn Mowing", "Edging", "Weed Treatment", "Overseeding", "Lawn Health Assessment"]
  },
  {
    id: 6,
    title: "Garden Design",
    description: "Professional garden design services to create bespoke, beautiful outdoor spaces. Our experts work with you from concept to final plan to ensure a functional and stunning garden tailored to your needs.",
    image: "https://customer-assets.emergentagent.com/job_london-garden-site/artifacts/cd0pqfuk_d3cd6acf-e8b9-4065-b1a3-5ef9c58a007c.jpeg",
    features: ["Site Survey & Analysis", "Concept Development", "2D & 3D Visuals", "Planting Plans", "Lighting & Irrigation Design"]
  },
  {
    id: 7,
    title: "Soft Landscaping", 
    description: "Expert soft landscaping services focusing on the living elements of your garden, including the supply and installation of healthy plants, trees, and shrubs to bring your design to life.",
    image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxwbGFudGluZ3xlbnwwfHx8fDE3NTQ4Mzc5NDJ8MA&ixlib=rb-4.1.0&q=85",
    features: ["Plant Supply & Installation", "Tree & Shrub Planting", "Border Preparation", "Mulching & Soil Conditioning", "Feature Planting"]
  },
  {
    id: 8,
    title: "Hard Landscaping",
    description: "Skilled hard landscaping services for all structural elements of your outdoor space. From laying patios and pathways to building walls and fences, we create the durable framework for your perfect garden.",
    image: "https://customer-assets.emergentagent.com/job_london-garden-site/artifacts/a0ilni2y_9f5ef68c-f757-4b28-bb9b-a8f9cc5cd9ce.jpeg",
    features: ["Patio & Paving Installation", "Decking Construction", "Retaining Wall Building", "Fence Installation & Repair", "Shed & Outbuilding Bases"]
  },
  {
    id: 9,
    title: "Planting Services",
    description: "Expert planting schemes to suit your space and style. Professional plant selection, installation, and ongoing care to create beautiful garden displays.",
    image: "https://customer-assets.emergentagent.com/job_balham-gardening-hub/artifacts/1eq1wuxc_Planting.jpeg",
    features: ["Plant Selection", "Flower Bed Design", "Seasonal Planting", "Bulb Planting", "Plant Care Advice"]
  },
  {
    id: 10,
    title: "Patio Services",
    description: "Professional patio installation, repair, and maintenance. From new patio construction to pressure washing and restoration of existing patios.",
    image: "https://customer-assets.emergentagent.com/job_balham-gardening-hub/artifacts/m5ax1zd3_Patio.jpeg",
    features: ["Patio Installation", "Patio Repair", "Pressure Washing", "Stone & Block Paving", "Patio Design"]
  },
  {
    id: 11,
    title: "Pruning",
    description: "Expert pruning services for trees, shrubs, and plants. Professional techniques to promote healthy growth and maintain the shape and size of your plants.",
    image: "https://customer-assets.emergentagent.com/job_balham-gardening-hub/artifacts/gwwh93vr_Pruning.jpeg",
    features: ["Tree Pruning", "Shrub Pruning", "Seasonal Pruning", "Health Assessment", "Shape Maintenance"]
  },
  {
    id: 12,
    title: "Trellis & Fencing",
    description: "Professional trellis installation and fencing services. Custom solutions for privacy, plant support, and garden structure. Quality materials and expert installation.",
    image: "https://customer-assets.emergentagent.com/job_balham-gardening-hub/artifacts/mt1mal3e_Trellis.jpeg",
    features: ["Trellis Installation", "Garden Fencing", "Privacy Screens", "Plant Support Systems", "Custom Design"]
  }
];

export const reviews = [
  {
    id: 1,
    name: "Verified Customer",
    rating: 10,
    date: "4 days ago",
    text: "Great communication from start to finish. Computerised drawing was provided so we could visualise the end result. The team arrived when they said they would, worked fast and efficiently. Delighted with the end result.",
    service: "Complete garden clearance and removal of waste, laying of lawn, jet washing patio",
    postcode: "SW19",
    lat: 51.4214,
    lng: -0.1878,
    images: [
      "https://storage.googleapis.com/core-media-service-production/user-media/01K20D7JF9PAXZC50HKQXKWQ2N.8A587B8F-ECA9-4B62-A048-F173619539FA.thumb.jpeg",
      "https://storage.googleapis.com/core-media-service-production/user-media/01K20D7JTQNTDA7ZV9RF88CCQD.36BE73D4-47B7-4FFD-A13C-072AB930D37F.thumb.jpeg"
    ]
  },
  {
    id: 2,
    name: "Verified Customer",
    rating: 10,
    date: "4 days ago",
    text: "Really great experience, the guys were friendly, helpful, informed and efficient. Cleared a really heavily congested garden with no issue and were very dilligent about it. Absolutely would recommend and go with again.",
    service: "Garden Clearance",
    postcode: "SW16",
    lat: 51.4325,
    lng: -0.1221,
    images: [
      "https://storage.googleapis.com/core-media-service-production/user-media/01K1Z59GTJSEAYJ1C52M16ZVX8.WhatsApp%20Image%202025-08-05%20at%2018.20.28_08e28d1a.thumb.jpg",
      "https://storage.googleapis.com/core-media-service-production/user-media/01K1Z59H44TRPFVJQSX8BA1GP4.WhatsApp%20Image%202025-08-05%20at%2018.20.26_8984b8ef.thumb.jpg"
    ]
  },
  {
    id: 3,
    name: "Verified Customer", 
    rating: 10,
    date: "5 days ago",
    text: "Booked on day of posting and completed within 2 hours of booking",
    service: "Dispose of thorny bush",
    postcode: "SW16",
    lat: 51.4352,
    lng: -0.1205,
    images: []
  },
  {
    id: 4,
    name: "Verified Customer",
    rating: 9,
    date: "6 days ago", 
    text: "PNM gardening were quick to quote from a photo and easy to communicate with. The two gardeners did a great job and cleared an overgrown garden really quickly and left no mess. Would recommend",
    service: "Small garden clearance",
    postcode: "SW12",
    lat: 51.4648,
    lng: -0.1731,
    images: []
  },
  {
    id: 5,
    name: "Verified Customer",
    rating: 10,
    date: "6 days ago",
    text: "Very good job, good communication and would use again.",
    service: "Ivy Removal",
    postcode: "SW10",
    lat: 51.4892,
    lng: -0.1934,
    images: []
  },
  {
    id: 6,
    name: "Verified Customer",
    rating: 9.3,
    date: "01 August",
    text: "Paolo and his team arrived promptly and worked hard to sort out our and our neighbour's front hedges. They were friendly and courteous and cleaned up well afterwards. The only negative was that their ladders were not quite tall enough to really trim the tops to perfection.",
    service: "Good hedge trimming",
    postcode: "SW4",
    lat: 51.4822,
    lng: -0.1448,
    images: []
  }
];

export const faqs = [
  {
    id: 1,
    question: "How can I get a quote?",
    answer: "You can get a free quote by filling out our contact form, calling us on 07340 833142, or emailing us at contact@pnmgardening.com. We provide fast and competitive quotes for all our services."
  },
  {
    id: 2,
    question: "Do you provide all the tools and equipment?",
    answer: "Yes, we come fully equipped with all the professional tools and equipment needed for any gardening task. You don't need to provide anything - we even have our own power source!"
  },
  {
    id: 3,
    question: "Are you fully insured?",
    answer: "Absolutely. We hold comprehensive Public Liability Insurance, so you can have complete peace of mind when we work on your property, whether residential or commercial."
  },
  {
    id: 4,
    question: "Do you take away all the garden waste?",
    answer: "Yes, we include free disposal of green waste with all our services. We remove all garden waste from your property and dispose of it responsibly at licensed facilities."
  },
  {
    id: 5,
    question: "What payment methods do you accept?",
    answer: "We accept cash, all major credit cards (Visa, MasterCard, American Express), and bank transfers (BACS). Payment is typically due upon completion of work."
  },
  {
    id: 6,
    question: "Can you supply plants, soil, and materials?",
    answer: "Yes, if you let us know your requirements when booking, we can supply plants, soil, compost, and other materials. We work with premium suppliers in London to ensure quality."
  },
  {
    id: 7,
    question: "Do I need to provide power for your tools?",
    answer: "No, you don't need to provide power for our tools. We come fully equipped with battery-powered and petrol-powered equipment, so no mains electricity is required. The only exception is our jet wash, which may need access to a garden tap in some cases."
  }
];

export const areasServed = [
  "Balham", "Tooting", "Wandsworth", "Clapham", "Streatham", "Mitcham",
  "Wimbledon", "Colliers Wood", "South Wimbledon", "Raynes Park",
  "New Malden", "Kingston upon Thames", "Putney", "Barnes", "Roehampton",
  "Earlsfield", "Southfields", "East Sheen", "Richmond", "Mortlake",
  "Chelsea", "Fulham", "Battersea", "Brixton", "Stockwell", "Vauxhall"
];

export const galleryImages = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1597201278257-3687be27d954?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxsYW5kc2NhcGluZ3xlbnwwfHx8fDE3NTQ4Mzc5NDJ8MA&ixlib=rb-4.1.0&q=85",
    title: "Beautiful Flower Garden",
    category: "Garden Design"
  },
  {
    id: 2,
    src: "https://images.pexels.com/photos/5905352/pexels-photo-5905352.jpeg",
    title: "Professional Garden Work",
    category: "Maintenance"
  },
  {
    id: 3,
    src: "https://images.pexels.com/photos/1301856/pexels-photo-1301856.jpeg",
    title: "Tree Surgery",
    category: "Tree Care"
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1458245201577-fc8a130b8829?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxsYW5kc2NhcGluZ3xlbnwwfHx8fDE3NTQ4Mzc5NDJ8MA&ixlib=rb-4.1.0&q=85",
    title: "Lawn Maintenance",
    category: "Lawn Care"
  }
];